// src/stores/gatewaySessionPrompt.js
// Bridges the axios 419 interceptor (plain JS, no component tree) to a modal component
// mounted once in App.vue. open() is awaited by the interceptor; the modal calls confirm()/cancel().
import { defineStore } from 'pinia'

export const useGatewaySessionPromptStore = defineStore('gatewaySessionPrompt', {
  state: () => ({
    visible: false,
    resolver: null,
  }),

  actions: {
    open() {
      this.visible = true
      return new Promise((resolve) => {
        this.resolver = resolve
      })
    },

    confirm() {
      this.visible = false
      if (this.resolver) this.resolver(true)
      this.resolver = null
    },

    cancel() {
      this.visible = false
      if (this.resolver) this.resolver(false)
      this.resolver = null
    },
  },
})
